import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './style.css'

const app = createApp(App)

// 註冊 Pinia
const pinia = createPinia()
app.use(pinia)

// 註冊 Router
app.use(router)

// 掛載應用程式
app.mount('#app')
